export const PLAN_CATALOG = [
  {
    name: 'On Demand',
    outcome: 'Explore the platform',
    idealFor: 'Individuals evaluating DCDial or managing occasional campaigns.',
    monthlyPrice: 0,
    annualMonthlyPrice: 0,
    users: '1',
    records: '500',
    concurrency: '5',
    campaigns: '1',
    workflows: '0',
    features: [
      'Core CRM and campaign-management tools',
      'Standard reporting',
      'Self-service onboarding',
    ],
    cta: 'Start with DCDial',
    group: 'core',
  },
  {
    name: 'Basic',
    outcome: 'Launch your operation',
    idealFor: 'Solo operators and very small teams managing a focused customer-engagement process.',
    monthlyPrice: 99,
    annualMonthlyPrice: 79,
    users: '3',
    records: '2,500',
    concurrency: '20',
    campaigns: '3',
    workflows: '3',
    features: [
      'CRM and campaign-management tools',
      'Basic workflow automation',
      'Standard reporting and support',
    ],
    cta: 'Choose Basic',
    group: 'core',
  },
  {
    name: 'Startup',
    outcome: 'Build repeatable growth',
    idealFor: 'Small teams introducing structured campaigns and repeatable automated processes.',
    monthlyPrice: 299,
    annualMonthlyPrice: 239,
    users: '8',
    records: '10,000',
    concurrency: '50',
    campaigns: '10',
    workflows: '15',
    features: [
      'Team collaboration',
      'Expanded workflow automation',
      'Reporting, analytics, and onboarding resources',
    ],
    cta: 'Choose Startup',
    group: 'core',
  },
  {
    name: 'Grow',
    outcome: 'Scale across your team',
    idealFor: 'Growing departments managing multiple campaigns and automated customer processes.',
    monthlyPrice: 899,
    annualMonthlyPrice: 719,
    users: '20',
    records: '50,000',
    concurrency: '100',
    campaigns: '25',
    workflows: '75',
    features: [
      'CRM and campaign-management tools',
      'Expanded automation and analytics',
      'Departmental capacity and priority support',
    ],
    cta: 'Choose Grow',
    badge: 'Most Popular',
    group: 'core',
  },
  {
    name: 'Pro',
    outcome: 'Run high-performance operations',
    idealFor: 'Established organizations managing substantial campaign activity and complex automation.',
    monthlyPrice: 1499,
    annualMonthlyPrice: 1199,
    users: '35',
    records: '100,000',
    concurrency: '200',
    campaigns: '50',
    workflows: '250',
    features: [
      'Advanced automation capacity',
      'Expanded reporting and analytics',
      'Administrative controls and implementation planning',
    ],
    cta: 'Choose Pro',
    badge: 'Advanced Operations',
    group: 'core',
  },
  {
    name: 'Silver',
    outcome: 'Coordinate multiple teams',
    idealFor: 'Organizations supporting several active teams, departments, or operational programs.',
    monthlyPrice: 2500,
    annualMonthlyPrice: 2000,
    users: '50',
    records: '250,000',
    concurrency: '350',
    campaigns: '100',
    workflows: '500',
    features: [
      'Multi-team operating capacity',
      'Advanced reporting',
      'Assisted implementation and enhanced support',
    ],
    cta: 'Talk to Sales',
    badge: 'High Volume',
    group: 'high-volume',
  },
  {
    name: 'Gold',
    outcome: 'Expand high-volume operations',
    idealFor: 'Large organizations managing extensive customer-engagement programs.',
    monthlyPrice: 6000,
    annualMonthlyPrice: 4800,
    users: '80',
    records: '500,000',
    concurrency: '750',
    campaigns: '250',
    workflows: '1,500',
    features: [
      'Organization-wide operating capacity',
      'Expanded analytics and reporting',
      'Integration and implementation assistance',
    ],
    cta: 'Talk to Sales',
    badge: 'High Volume',
    group: 'high-volume',
  },
  {
    name: 'Platinum',
    outcome: 'Power complex enterprise operations',
    idealFor: 'Enterprises with sophisticated processes spanning multiple teams or departments.',
    monthlyPrice: 12000,
    annualMonthlyPrice: 9600,
    users: '125',
    records: '1,000,000',
    concurrency: '1,200',
    campaigns: '500',
    workflows: '5,000',
    features: [
      'Enterprise operating capacity',
      'Advanced administrative options',
      'Enterprise rollout planning and support',
    ],
    cta: 'Contact Sales',
    badge: 'Enterprise',
    group: 'high-volume',
  },
  {
    name: 'Everything',
    outcome: 'Maximize platform capacity',
    idealFor: 'Large-scale and multi-brand deployments requiring DCDial’s highest published allowances.',
    monthlyPrice: 20000,
    annualMonthlyPrice: 16000,
    users: '200',
    records: '2,500,000',
    concurrency: '2,000',
    campaigns: 'Unlimited',
    workflows: 'Unlimited',
    features: [
      'Highest standard platform capacity',
      'Multi-brand operating support',
      'Custom implementation and support planning',
    ],
    cta: 'Contact Sales',
    badge: 'Maximum Scale',
    group: 'high-volume',
  },
];

export const PLAN_DEFINITIONS = [
  {
    term: 'Users',
    definition: 'Named team members who can access the platform. This is not a simultaneous-login limit.',
  },
  {
    term: 'Active records',
    definition: 'Customer records available for campaigns, workflows, reporting, and daily operations. Archived records do not count.',
  },
  {
    term: 'Concurrency',
    definition: 'The maximum number of outbound campaign actions the DCDial software can coordinate simultaneously.',
  },
  {
    term: 'Active campaigns',
    definition: 'Enabled or scheduled campaigns. Draft, paused, completed, and archived campaigns do not count.',
  },
  {
    term: 'Active workflows',
    definition: 'Published and enabled automations. Draft, disabled, and archived workflows do not count.',
  },
];

export const PAYMENT_PRICING = {
  dcdialProcessor: {
    name: 'Use the DCDial processor',
    monthlyFee: 0,
    rates: [
      { method: 'Card', rate: '3.5% + 50¢' },
      { method: 'Bank', rate: '2% (capped at $20)' },
      { method: 'Wire', rate: '$20' },
    ],
    qualifier: 'Per successful transaction — you pay only when you get paid.',
  },
  ownProcessor: {
    name: 'Use your own processor',
    tiers: [
      { revenue: 'Annual revenue under $2.4M', monthlyFee: 599, revenueShare: '0.9% of revenue' },
      { revenue: 'Annual revenue $2.4M–$6M', monthlyFee: 1499, revenueShare: '0.7% of revenue' },
      { revenue: 'Annual revenue over $6M', monthlyFee: 3499, revenueShare: '0.5% of revenue' },
    ],
  },
};

export const normalizePlanName = (name = '') =>
  name.trim().toLowerCase().replace(/\s+/g, ' ');
